module.exports = __webpack_public_path__ + "static/img/zycp_shehuixing_a.4156a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/zycp_shehuixing_a.jpg
// module id = fs+b
// module chunks = 1